export const OPEN_MODAL = 'SETTINGS/OPEN_CREATE_ORGANIZATION_MODAL';
export const CLOSE_MODAL = 'SETTINGS/CLOSE_CREATE_ORGANIZATION_MODAL';
